import { createContext, useContext, useReducer } from "react";

interface ISecureState {
    isSecure: boolean;
}

interface ISecureContext extends ISecureState {
    toggleSecure: () => void;
}

interface ISecureProviderProps {
    children: React.ReactNode;
}

const SecureContext = createContext<ISecureContext|null>(null);

const initialState: ISecureState = {
    isSecure: false
}

const reducer = (state: ISecureState, action: { type: string; }) => {
    switch (action.type) {
        case "Show":
            return {
                ...state,
                isSecure: false
            }
        case "Hide":
            return {
                ...state,
                isSecure: true
            }
        default:
            throw new Error(`Type ${action.type} is not implemented.`);
    }
}

const SecureProvider = ({ children }: ISecureProviderProps) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const toggleSecure = () => {
        if (state.isSecure)
            dispatch({ type: "Show" });
        else
            dispatch({ type: "Hide" });
    }

    return (
        <SecureContext.Provider value={{ ...state, toggleSecure }}>
            {children}
        </SecureContext.Provider>
    );
}

const useSecureContext = () => {
    const context = useContext(SecureContext);

    if (!context)
        throw new Error(`SecureContext cannot be null`);

    return context;
}

export { SecureProvider, useSecureContext }
